import React, { useEffect, useState, useCallback } from "react";
import { Flex, Input, Button, Modal, message } from "antd";
import { SearchOutlined, RobotOutlined } from "@ant-design/icons";
import DraggableWidget from "./components/DraggableWidget";
import { newWidgets, layoutWidgets } from "./widgetsData";
import { useTranslation } from "react-i18next";

const SiderLeft = ({ onGenerateForm }) => {
    const { t } = useTranslation();
    const [filteredWidgets, setFilteredWidgets] = useState([])
    const [filteredLayoutWidgets, setFilteredLayoutWidgets] = useState([])
    const [searchText, setSearchText] = useState('')
    const [promptOpen, setPromptOpen] = useState(false)
    const [promptText, setPromptText] = useState("")
    const [isGenerating, setIsGenerating] = useState(false)

    const getWidgetSearch = useCallback(() => {
        const query = (searchText || '').trim().toLowerCase();
        if (query) {
            const result = newWidgets.filter(widget => (widget.label || '').toLowerCase().includes(query));
            setFilteredWidgets(result);
            const layoutResult = layoutWidgets.filter(widget => (widget.label || '').toLowerCase().includes(query));
            setFilteredLayoutWidgets(layoutResult);
        } else {
            setFilteredWidgets([...newWidgets]);
            setFilteredLayoutWidgets([...layoutWidgets]);
        }
    }, [searchText])    
    useEffect(() => {
        getWidgetSearch();
    }, [getWidgetSearch])

    const handlePromptSubmit = async () => {
        const trimmedPrompt = (promptText || "").trim()
        if (!trimmedPrompt) {
            message.error(t('Please enter a prompt.'))
            return
        }
        if (!onGenerateForm) {
            message.error(t('Form generator is not available.'))
            return
        }
        setIsGenerating(true)
        const result = await onGenerateForm(trimmedPrompt)
        setIsGenerating(false)
        if (result?.ok) {
            setPromptText("")
            setPromptOpen(false)
        }
    }

    return (
        <div className="sider-left-container">
            <div className="text-regular" style={{ textAlign: "left" }}>{t("Elements")}</div>
            <Input placeholder={t("Search")} suffix={<SearchOutlined />} onChange={(e) => setSearchText(e.target.value)} value={searchText} allowClear />
            {/* <Button
                type="default"
                icon={<RobotOutlined />}
                style={{ width: "100%" }}
                onClick={() => setPromptOpen(true)}
            >
                Generate From Prompt
            </Button> */}
            <Flex className="widgets-container flex-1">
                {/* <div className="text-regular" style={{ textAlign: "left" }}>Input Fields</div> */}
                <Flex className="widgets-col">
                    {
                        filteredWidgets.map((widget, index) => (
                            <DraggableWidget
                                key={widget.id}
                                {...widget}
                            />
                        ))
                    }
                </Flex>
                <div className="text-regular" style={{ textAlign: "left" }}>{t("Layout")}</div>
                <Flex className="widgets-col">
                    {
                        filteredLayoutWidgets.map((widget, index) => (
                            <DraggableWidget
                                key={widget.id}
                                {...widget}
                            />                        ))
                    }
                </Flex>
            </Flex>
            <Modal
                title={t('Generate Form')}
                open={promptOpen}
                onCancel={() => setPromptOpen(false)}
                footer={null}
                destroyOnHidden
            >
                <Input.TextArea
                    rows={6}
                    placeholder={t('Describe the form you want to generate...')}
                    value={promptText}
                    onChange={(e) => setPromptText(e.target.value)}
                />
                <Flex justify="flex-end" gap={8} style={{ marginTop: "12px" }}>
                    <Button onClick={() => setPromptOpen(false)} disabled={isGenerating}>
                        {t('Cancel')}
                    </Button>
                    <Button type="primary" onClick={handlePromptSubmit} loading={isGenerating}>
                        {isGenerating ? "In action..." : "Go"}
                    </Button>
                </Flex>
            </Modal>
        </div>
    )
}

export default SiderLeft
